import { ApiBilling } from "@incendium/api";
import { listBilling } from "features/ai/services/aiService";
import { useGlobalSharedState } from "Hooks/useSharedState";

const fetchBillings = async (): Promise<ApiBilling[]> => {
  const billings = await listBilling();
  return billings ?? [];
};

const useAIBillings = () => {
  const { state, setState, loading, refetch } = useGlobalSharedState<ApiBilling[]>(
    "aiBillings",
    [],
    fetchBillings
  );

  return {
    billings: state,
    setBillings: setState,
    loading,
    refetch,
  };
};

export default useAIBillings;
